export const GET_PROMOTION_PRODUCT_BY_SLUG = "GET_PROMOTION_PRODUCT_BY_SLUG"
export const GET_PROMOTION_PRODUCT_BY_SLUG_SUCCESS = "GET_PROMOTION_PRODUCT_BY_SLUG_SUCCESS"

export const GET_PROMOTIONS_PRODUCTS_BY_SECTION_CATEGORY = "GET_PROMOTIONS_PRODUCTS_BY_SECTION_CATEGORY"
export const GET_PROMOTIONS_PRODUCTS_BY_SECTION_CATEGORY_SUCCESS = "GET_PROMOTIONS_PRODUCTS_BY_SECTION_CATEGORY_SUCCESS"

export const GET_PROMOTION_PRODUCTS_API_ERROR = "GET_PROMOTION_PRODUCTS_API_ERROR"
